export default __webpack_public_path__ + "static/media/ep2.6eac9d0f.png";